import { useQuery } from "@tanstack/react-query";
import { getAlertsForDashboard } from "../../../api/alertsApi";
import { AlertItem } from "../../../pages/Alerts/alertsMockData";
import { useDashboardRegistry } from "../dashboards/useDashboardRegistry";

// Feeds the per-dashboard alert widget (DefaultPageContent/IframeLayout) - a separate, scoped
// query key from useAlerts()'s all-alerts entry, but still invalidated together (see
// useDismissAlert/useSnoozeAlert) since react-query v4 invalidates by key prefix.
//
// GET /alerts/dashboard/{dashboard_id} takes the dashboard's real numeric id, not its route path -
// this resolves that id from the already-fetched registry (matching by `path`) rather than
// changing every call site to thread an id through instead of the path it already has.
export const useDashboardAlerts = (dashboardPath: string | null) => {
  const { dashboards } = useDashboardRegistry();
  const dashboardId = dashboards.find((dashboard) => dashboard.path === dashboardPath)?.id ?? null;

  const { data, isLoading } = useQuery<AlertItem[]>(
    ["alerts", "dashboard", dashboardId],
    () => getAlertsForDashboard(dashboardId as number),
    { enabled: dashboardId !== null }
  );
  return { alerts: data ?? [], isLoading };
};
